import React from 'react';
import RecordsContainer from '../components/formatos/Records/RecordsContainer';
import WebpackerReact from 'webpacker-react';

function RecordsIndex(props) {
  return <RecordsContainer {...props} />;
}

export default RecordsIndex;
WebpackerReact.setup({ RecordsIndex });
